import styled from "styled-components";

export const TooltipItemContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: 100%;
`;

export const CompanyWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
`;
export const CompanyText = styled.p``;
